<form [formGroup]="searchForm" (ngSubmit)="doSearch()">
  <div class="searchRadios">
    <div class="form-check form-check-inline">
      <input
        type="radio"
        value="flight"
        class="form-check-input"
        id="searchFlight"
        formControlName="searchOption"
        checked="checked"
        (click)="resetSearchText()"
      />
      <label class="form-check-label" for="searchFlight">Flight</label>
    </div>
    <div class="form-check form-check-inline">
      <input
        type="radio"
        value="ship"
        class="form-check-input"
        id="searchShip"
        formControlName="searchOption"
        (click)="resetSearchText()"
      />
      <label class="form-check-label" for="searchShip">Ship</label>
    </div>
  </div>
  <div class="search-input">
    <input
      type="text"
      #searchTextField
      required
      formControlName="searchText"
      (keypress)="numberOnly($event)"
      [maxLength]="getMaxLength()"
    />
    <span class="highlight"></span>
    <span class="bar"></span>
    <label>Search</label>
    <emt-delta-icon class="icon-search" iconName="icon-search" (click)="doSearch()"></emt-delta-icon>
  </div>
</form>
